import React from 'react';

export const VolEventEndDateModal = {
  title: 'Eruption End Date',
  body: (
    <div>
      <p>
        Where available, this date (SYYYY-MM-DD) indicates the end date of the
        eruption. When an exact day is not available, this date defaults to the
        last day of the specified month (e.g. SYYYY-MM-31).  When only a year is
        available, this date defaults to the last month and day of that year
        (e.g. SYYYY-12-31).
      </p>
    </div>
  ),
};
